var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerWithBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3334C14.6024 18.3334 18.3334 14.6025 18.3334 10.0001C18.3334 5.39771 14.6024 1.66675 10 1.66675C5.39765 1.66675 1.66669 5.39771 1.66669 10.0001C1.66669 14.6025 5.39765 18.3334 10 18.3334Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.16675C9.53919 9.16675 9.16669 8.79341 9.16669 8.33341V5.00008C9.16669 4.54008 9.53919 4.16675 10 4.16675C10.4609 4.16675 10.8334 4.54008 10.8334 5.00008V8.33341C10.8334 8.79341 10.4609 9.16675 10 9.16675Z",
    fill: "#6C6C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8334C6.78419 15.8334 4.16669 13.2167 4.16669 10.0001C4.16669 8.34424 4.87502 6.76007 6.10919 5.65424C6.45002 5.34757 6.97669 5.37591 7.28585 5.71841C7.59252 6.06174 7.56335 6.58841 7.22085 6.89507C6.33919 7.68591 5.83335 8.81757 5.83335 10.0001C5.83335 12.2976 7.70252 14.1667 10 14.1667C12.2975 14.1667 14.1667 12.2976 14.1667 10.0001C14.1667 8.82007 13.6634 7.69091 12.7859 6.90174C12.4442 6.59341 12.4159 6.06674 12.7242 5.72424C13.0317 5.38257 13.5592 5.35507 13.9009 5.66174C15.1284 6.76757 15.8334 8.34841 15.8334 10.0001C15.8334 13.2167 13.2159 15.8334 10 15.8334Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerWithBack);
export default __webpack_public_path__ + "static/media/power-with-back.63bb80a5c8c1dbb17e5742af67145a47.svg";
export { ForwardRef as ReactComponent };